import { Component, Host, h, Prop, Element } from '@stencil/core';

@Component({
  tag: 'me-if',
  styleUrl: 'me-if.scss',
  shadow: false,
})
export class MeIf {

  @Element() host: HTMLMeIfElement;

  @Prop() not = false;
  @Prop() environment?: string;
  @Prop() value?: string;
  @Prop() fcmsApp?: boolean;

  private hasElseBranch = false;

  componentWillLoad() {
    this.hasElseBranch = Boolean(this.host.querySelector(':scope > [slot=else]'));
  }

  render() {
    const classList = [
      'me-if',
      this.isSatisfied() ? 'me-if--satisfied' : null,
    ].filter(c => !!c).join(' ');

    return (
      <Host class={classList}>
        <div class="me-if__if-branch">
          <slot></slot>
        </div>
        {this.hasElseBranch
          ? (
            <div class="me-if__else-branch">
              <slot name="else"/>
            </div>
          )
          : ''
        }
      </Host>
    );
  }

  /**
   * Returns whether the conditions are satisfied or not;
   * takes into account the `this.not` property;
   * i.e. inverts the logic.
   */
  private isSatisfied() {
    const isSatisfied = this.isEnvironmentSatisfied()
      && this.isValueSatisfied()
      && this.isFcmsAppSatisfied();

    return this.not
      ? !isSatisfied
      : isSatisfied;
  }

  private isEnvironmentSatisfied() {
    return this.host.hasAttribute('environment')
      ? this.environment
        .split(/(\s|,)/)
        .some(environment => bowser.is(environment, true))
      : true;
  }

  private isValueSatisfied() {
    if (!this.host.hasAttribute('value')) { return true; }

    switch (this.value.trim()) {
      case 'false':
      case '0':
      case '':
        return false;
      default:
        return true;
    }
  }

  private isFcmsAppSatisfied() {
    if (!this.host.hasAttribute('fcms-app')) { return true; }

    const isFcmsApp = /fcms(Web|iOS)App/i.test(navigator.userAgent);

    return this.fcmsApp
      ? isFcmsApp
      : !isFcmsApp;
  }

}
